import { useGetMerchantTerminalContractQuery } from "Api/Queries/Merchants/useGetMerchantTerminalContractQuery";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { ContractDetail } from "Components/Shared/Merchant/Products/TerminalContracts/ContractDetail";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  isOpen: boolean;
  merchantPublicID: string;
  terminalContractPublicID: string;
};

export const ViewContractDialogContent = ({
  isOpen,
  merchantPublicID,
  terminalContractPublicID,
}: Props) => {
  const { t } = useResource();
  const { data, isFetching } = useGetMerchantTerminalContractQuery(
    merchantPublicID,
    terminalContractPublicID,
    isOpen,
  );

  if (!isOpen) {
    return null;
  }

  if (isFetching) {
    return <CenteredCircularProgress />;
  }

  if (!data) {
    return (
      <ErrorText>
        {t(Resources.Components.Merchant.TerminalContracts.LoadingError)}
      </ErrorText>
    );
  }

  return <ContractDetail contract={data} />;
};
